module.exports = __webpack_public_path__ + "img/taxi.42cb9978.png";